import axios from "axios";
import React, { useEffect, useState } from "react";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";
import EnvioRotogramaViagemPopup from "../../Relatorios/RotogramaViagem/EnvioRotogramaViagemPopup";
import ColunasGridNaoIniciadaPopup from "./ColunasGridNaoIniciadaPopup";
import parse from "html-react-parser";

const GridNaoIniciadasTab = (props: any) => {
  const [responseRows, setResponseRows] = useState<any>({});
  const [dadosViagem, setDadosViagem] = useState<any>({});
  const [envioRotogramaOpen, setEnvioRotogramaOpen] = useState(false);
  const [colunasGridOpen, setColunasGridOpen] =
    useState(false);
  const [colunas, setColunas] = useState<any[]>([]);

  useEffect(() => {
    const carregar = async () => {
      await carregaGrid();
    };

    carregar();
  }, []);

  function onCloseColunasGrid() {
    setColunasGridOpen(false);
    carregaGrid();
  }

  async function carregaGrid() {
    let response: any = await axios.get(
      `colunasGridVisualizacao?gridId=nao_iniciada`,
    );

    const colunas = response.data.map((coluna: any) => ({
      dataIndex: coluna.identificador,
      title: coluna.nome,
      minWidth: coluna.width || 150,
      render: (value: string) => parse(`${(value  ?? '')}`)
      // flex: 0.2,
    }));

    setColunas(colunas);
  }

  async function atualizaListaBuscaCallBack(
    pageSize: number,
    pageNumber: number)
  {
    let response: any = await axios.get(
      `buscaDadosGridNaoIniciada?page=${pageNumber}&pageSize=${pageSize}`,
    );

    props.setLabel(`Não Iniciadas (${response.data.total})`);

    setResponseRows(response);
  }

  function selecionaViagem(id: any) {
    setDadosViagem({ id: id });
    setEnvioRotogramaOpen(true);
  }

  return (
    <>
      <div className="col-md-12" style={{ height: "100%" }}>
        <DataGridComponent
          heightFix={70}
          directionOptions="left"
          paginationSide="server"
          hideDelete={true}
          onEditAction={selecionaViagem}
          onDeleteAction={() => alert(1)}
          responseRows={responseRows}
          columns={colunas}
          pageSizeOptions={["15", "30", "50", "100"]}
          atualizaListaBuscaCallBack={atualizaListaBuscaCallBack}
          openGridSettings={() => setColunasGridOpen(true)}
        />
      </div>

      {colunasGridOpen ? (
        <ColunasGridNaoIniciadaPopup
          isOpen={colunasGridOpen}
          onClose={() => onCloseColunasGrid()}
        />
      ) : (
        ""
      )}
      {envioRotogramaOpen ? (
        <EnvioRotogramaViagemPopup
          viagemId={dadosViagem.id}
          isOpen={envioRotogramaOpen}
          onClose={() => setEnvioRotogramaOpen(false)}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default GridNaoIniciadasTab;
